export const DELETE_OFFLINE_INVESTOR_ATTEMPT = 'DELETE_OFFLINE_INVESTOR_ATTEMPT';
export type DELETE_OFFLINE_INVESTOR_ATTEMPT = typeof DELETE_OFFLINE_INVESTOR_ATTEMPT;

export const DELETE_OFFLINE_INVESTOR_SUCCESS = 'DELETE_OFFLINE_INVESTOR_SUCCESS';
export type DELETE_OFFLINE_INVESTOR_SUCCESS = typeof DELETE_OFFLINE_INVESTOR_SUCCESS;

export const DELETE_OFFLINE_INVESTOR_FAILURE = 'DELETE_OFFLINE_INVESTOR_FAILURE';
export type DELETE_OFFLINE_INVESTOR_FAILURE = typeof DELETE_OFFLINE_INVESTOR_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/project/offline-investor/delete/Types.tsx